import {gql} from 'apollo-angular';

export const GET_SCHOOL_BY_TEACHER = gql`
  query getSchoolByTeacher {
    getSchoolByTeacher {
      id, name, url
    }
  }
`;
